import React, { useState } from "react";

const LeadsPage: React.FC = () => {
  const [number, setNumber] = useState("");
  const [nominativo, setNominativo] = useState("Francesco Scordamaglia");
  const campaignOptions = ["Corsi ecm crediti elevati", "Catalogo ecm"];

  const [selectedCampaign, setSelectedCampaign] = useState(campaignOptions[0]);
  const [descriptionCampaign, setDescriptionCampaign] = useState(
    "campagna di formazione quotidiano sanità"
  );

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(
        "https://apim.consulcesi.com/crmmedici-out/api/dial/leads/test-internal",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            params_AI: {
              number,
              campaign: selectedCampaign,
              description_campaign: selectedCampaign,
              nominativo,
            },
            params_internal: {},
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Errore durante l'invio del lead");
      }

      setMessage("Lead inviato con successo");
    } catch (error) {
      console.error(error);
      setMessage("Errore durante l'invio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Test Lead</h1>
          <p style={styles.subtitle}>
            Compila i dati del lead e invia la richiesta al dialer.
          </p>
        </div>

        <div style={styles.form}>
          <Field
            label="Numero"
            value={number}
            placeholder="00393400000000"
            onChange={setNumber}
          />

          <Field
            label="Nominativo"
            value={nominativo}
            onChange={setNominativo}
          />

          <div style={styles.field}>
            <label style={styles.label}>Campagna</label>
            <select
              value={selectedCampaign}
              onChange={(e) => setSelectedCampaign(e.target.value)}
              style={styles.input}
            >
              {campaignOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading || !number.trim()}
            style={{
              ...styles.button,
              ...(loading || !number.trim() ? styles.buttonDisabled : {}),
            }}
          >
            {loading ? "Invio in corso..." : "Invia Lead"}
          </button>

          {message && <div style={styles.message}>{message}</div>}
        </div>
      </div>
    </div>
  );
};

type FieldProps = {
  label: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

const Field: React.FC<FieldProps> = ({
  label,
  value,
  placeholder,
  onChange,
}) => {
  return (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={styles.input}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh",
    background: "#f4f6fb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
  },
  card: {
    width: "100%",
    maxWidth: 640,
    background: "#ffffff",
    borderRadius: 20,
    padding: 32,
    boxShadow: "0 20px 50px rgba(15, 23, 42, 0.12)",
    border: "1px solid rgba(15, 23, 42, 0.08)",
  },
  header: {
    marginBottom: 28,
  },
  title: {
    margin: 0,
    fontSize: 30,
    fontWeight: 700,
    color: "#111827",
  },
  subtitle: {
    margin: "8px 0 0",
    fontSize: 15,
    color: "#6b7280",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: "#374151",
  },
  input: {
    width: "100%",
    height: 46,
    borderRadius: 12,
    border: "1px solid #d1d5db",
    padding: "0 14px",
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box",
    background: "#ffffff",
  },
  button: {
    marginTop: 8,
    height: 48,
    border: "none",
    borderRadius: 12,
    background: "#2563eb",
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
  },
  buttonDisabled: {
    background: "#93c5fd",
    cursor: "not-allowed",
  },
  message: {
    padding: "12px 14px",
    borderRadius: 12,
    background: "#f3f4f6",
    color: "#374151",
    fontSize: 14,
  },
};

export default LeadsPage;
